module.exports = __webpack_public_path__ + "img/08.f6a2375d.png";